import Vue from 'vue'
import Vuex from 'vuex'
import cookie from '@/storage/cookies.js'
// import link from '@/public/link.js'
import apiUser from '@/public/apiUser/apiUser'
import createLogger from 'vuex/dist/logger'
Vue.use(Vuex)
const debug = process.env.NODE_ENV !== 'production'
const store = new Vuex.Store({
  state: {
    menuActiveNum: 0, // 导航栏激活
    routerObj: {},
    isOpen: false,
    toUser: '',
    authUser: {},
    session: [], // 消息会话
    friends: [], // 好友列表
    teams: [], // 群组列表
    msgs: {}, // msgs：消息对象集合
    upload: `${process.env.VUE_APP_APIUSER}/file/add`,
    indexKey: -1,
    loginType: false,
    token: '',
    user: {},
    areaList: [], // 所有地区
    area: {}, // 地区选择
    teamIndex: 0,
    workerIndex: 0,
    identifiers: [], // 用户访问权限
    authorization: 0,//企业权限（判断当前登录用户是否为该公司管理员）
    // IM
    showImChat: false,
    openMeeting: false,
    imAccount: '',
    imToken: '',
    // upload: `${process.env.VUE_APP_APITEAM}/file/add`,
    // uploadMess: `${process.env.VUE_APP_APITEAM}/file/recognition`,
    // otherUpload: `file/add`,
    // otherUploadMess: `file/recognition`
    position: {
      lng: 0,
      lat: 0
    },
    firstCategoryNo:''//工程分类一级
  },
  mutations: {
    // 打开交流弹框
    setChatStatus(state, showImChat) { // 新版IM交流
      state.showImChat = showImChat
    },
    setMeetingStatus(state, status) {
      state.openMeeting = status
    },
    /** @name 施工工队选项卡点击索引 */
    SET_TEAMINDEX(state, val) {
      state.teamIndex = val
    },
    /** @name 找工人选项卡点击索引 */
    SET_WORKERINDEX(state, val) {
      state.workerIndex = val
    },
    SET_AUTHUSER(state, auth) {
      state.authUser = auth
      state.identifiers = auth.identifiers || []

    },
    SET_ROUTERKEY(state, token) {
      state.routerObj = token
    },
    SET_INDEXKEY(state, token) {
      state.indexKey = token
    },
    SET_TOKEN(state, token) {
      if(!token){
        window.noticeWs && window.noticeWs.close()
        window.noticeWs = null
      }else if(token && !window.noticeWs){
        let url = process.env.VUE_APP_NOTIFYWS
        window.noticeWs = new zjNotifySocket({url,token})
      }
      state.token = token
    },
    SET_LOGINTYPE(state, loginType) {
      state.loginType = loginType
    },
    SET_USER(state, user) {
      state.user = user
      // localStorage.setItem("isLoginType", JSON.stringify(true))
      sessionStorage.setItem("store", JSON.stringify(state))
    },
    // 好友列表
    SET_FRIENDS(state, friends) {
      state.friends = friends
    },
    // 删除好友
    DELETE_FRIEND(state, account) {
      let list = window.nim.cutFriendsByAccounts(state.friends, account)
      state.friends = Object.assign({}, list)
    },
    LOGIN_OUT(state) {
      cookie.cookieClear('token')
      cookie.cookieClear('USER_ACCESS_TOKEN')
      state.token = null
      state.user = {}
      state.loginType = false
      sessionStorage.clear('store')
      // localStorage.clear("isLoginType")
      //路由白名单，退出时返回首页
      let path = ['/record', '/IndividualRecord']
      if (path.includes(_vue.$route.path)) {
        _vue.$router.push({ path: '/' })
      }
      // link.login()
      //location.reload()//刷新页面
    },
    // 设置消息列表
    SET_MSGS(state, msgs) {
      if (!Array.isArray(msgs)) {
        // eslint-disable-next-line no-param-reassign
        msgs = [msgs]
      }
      if (!msgs[0]) return
      let sessionId = msgs[0].sessionId
      let value = window.nim.mergeMsgs(state.msgs[sessionId], msgs)
      state.msgs[sessionId] = value
      state.msgs = Object.assign({}, state.msgs)
    },
    // 删除消息
    DELMSYS(state, obj) {
      state.msgs[obj.msg.sessionId].forEach((item, index) => {
        if (item.idServer === obj.msg.idServer) {
          state.msgs[obj.msg.sessionId].splice(index, 1, obj.data)
        }
      })
    },
    // 设置系统消息列表
    SET_SYSMSGS(state, sysMsgs) {
      if (!Array.isArray(sysMsgs) && sysMsgs.type === 'deleteMsg' && state.msgs[sysMsgs.msg.sessionId]) {
        state.msgs[sysMsgs.msg.sessionId].forEach((item, index) => {
          if (item.idServer === sysMsgs.deletedIdServer) {
            state.msgs[sysMsgs.msg.sessionId].splice(index, 1)
            // eslint-disable-next-line no-undef
            nimTool.sendTipMsg(sysMsgs.msg, state)
          }
        })
      }
      let sysMagList = Array.isArray(sysMsgs) ? sysMsgs : [sysMsgs]
      let delemsg = sysMagList.filter(item => {
        return !item.type && item.type === 'deleteMsg'
      })
      if (delemsg.length > 0) {
        window.nim.markSysMsgRead({
          sysMsgs: delemsg,
          done: (err, obj) => {
          }
        })
        let ids = delemsg.map(item => (item.idServer))
        window.nim.deleteLocalSysMsg({
          idServer: ids,
          done: (err, obj) => {
          }
        })
      }
      state.sysMsgs = window.nim.mergeSysMsgs(state.sysMsgs, sysMsgs)
    },
    // 更新未读数
    updatwSysMsgUnread(state, obj) {
      state.sysMsgUnread = obj
    },
    // 更新系统消息
    updatwCustomSysMsgs(state, obj) {
      let value = state.customSysMsgs
      value.push(obj)
      state.customSysMsgs = value
    },
    // 会话消息
    SET_SESSION(state, obj) {
      state.session = window.nim.mergeSessions(state.session, obj)
    },
    // 更新会话
    UPDATE_SESSION(state, obj) {
      let sortIndex = ''
      state.session.forEach((item, index) => {
        if (item.id === obj.id) {
          sortIndex = index
        }
      })
      if (sortIndex !== '') {
        state.session.splice(sortIndex, 1, obj)
      } else {
        state.session.push(obj)
      }
    },
    // 设置toUser
    SETTOUSER(state, id) {
      if (!state.isOpen) return
      state.toUser = id
    },
    DELETE_SESSION(state, id) {
      state.session.forEach((item, index) => {
        if (item.id === id) {
          state.session.splice(index, 1)
        }
      })
    },
    // 更新nim链接状态
    updateNimState(state, flg) {
      state.nimState = flg
    },
    // 设置是否展开
    SET_ISOPEN(state, flg) {
      if (flg) {
        state.toUser = state.session[0] ? state.session[0].to : ''
      } else {
        state.toUser = ''
      }
      state.isOpen = flg
    },
    // 这里
    SET_AREA(state, item) {
      state.area = item
    },
    SET_AREALIST(state, areaList) {
      state.areaList = areaList
    },
    //
    SET_authorization(state, user) {
      // 首先判断当前登录身份若是自己的企业那么就可以发布
      if (user.comName === state.user.mainComName) {
        state.authorization = 1;
      }
      //若是当前身份是加入的企业要判断有无权限
      else if (user.comName != state.user.mainComName) {
        if (user.identifiers.indexOf("teamInfoList" || "gdbjList" || "needsWorkerList" || "flexWorkerList") != -1) {
          state.authorization = 1;
        }
      }
    },
    //每次切换身份确定其authorization初始值为0
    changeauthorization(state) {
      state.authorization = 0;

    },
    SET_POSITION(state, position) {
      state.position = position
    },
    SET_FirstCategoryNo(state, firstCategoryNo) {
      state.firstCategoryNo = firstCategoryNo
    },

  },
  getters: {
    getUser(state) {
      return state.user
    }
  },
  actions: {
    async setUser({
      commit
    }) {
      let token = cookie.cookieRead('token')

      let res = await apiUser.getUserInfo()
      let user = res.data.data
      commit('SET_LOGINTYPE', true)
      commit('SET_TOKEN', token)
      commit('SET_USER', user)
      // commit("SET_authorization",user)
      // this.$store.dispatch('setUser')


      // let resNew = await apiUser.getJurisdiction()
      // if (resNew.data.result) {
      //   // let arr = resNew.data.result.routes;
      //   // let pushArr = [];
      //   // await append(pushArr, arr);
      //   commit('SET_AUTHUSER', resNew.data.result)
      //   // commit("SET_ALL_JURI", pushArr);
      // } else {
      //   // commit("SET_ALL_JURI", []);
      // }
    }
  },
  // strict: process.env.NODE_ENV !== 'production',
  // plugins: debug ? [createLogger()] : []
})
export default store
